import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="gradient-bg relative flex min-h-0 items-center overflow-hidden py-10 text-white sm:py-14 md:py-16 lg:min-h-[82vh] lg:py-16">
      <div className="absolute inset-0 opacity-10">
        <div className="animate-pulse-slow absolute left-10 top-20 h-40 w-40 rounded-full bg-white" />
        <div className="animate-float absolute bottom-20 right-10 h-32 w-32 rounded-full bg-cyan-300" />
        <div className="animate-pulse-slow absolute left-1/3 top-1/2 h-24 w-24 rounded-full bg-blue-300" />
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-8 md:gap-16 lg:grid-cols-2">
          <div className="animate-fade-in">
            <div className="mb-3 md:mb-5">
              <span className="rounded-full bg-white/15 px-3 py-1.5 text-xs font-semibold backdrop-blur-sm md:text-sm">
                Contractor business platform
              </span>
            </div>
            <h1 className="mb-4 text-2xl font-black leading-tight md:text-4xl lg:text-[2.65rem] lg:leading-[1.15]">
              Run your contracting business from{' '}
              <span className="text-cyan-300">one clean platform.</span>
            </h1>
            <p className="mb-7 max-w-xl text-sm leading-relaxed text-cyan-100/95 md:mb-8 md:text-base">
              DevelloTech helps contractors create professional quotes, manage clients, organize projects, track job costs,
              and keep every job detail in one place - built for contractors across Canada and the United States.
            </p>
            <div className="mb-4 flex flex-col gap-3 sm:flex-row md:mb-6 md:gap-4">
              <Link to="/account" className="block sm:inline-block">
                <button
                  type="button"
                  className="btn-primary w-full rounded-2xl px-6 py-3 text-sm font-bold text-white sm:w-auto md:px-8 md:py-3 md:text-base"
                >
                  Start Building Invoices
                </button>
              </Link>
              <a
                href="#why-contractors"
                className="glass-effect flex items-center justify-center rounded-2xl border border-white/20 px-6 py-3 text-sm font-semibold text-white transition-all hover:bg-white/20 sm:inline-flex md:px-8 md:py-3 md:text-base"
              >
                View Features
              </a>
            </div>
            <ul className="grid max-w-xl grid-cols-1 gap-2 text-xs text-blue-100/95 md:text-sm">
              {[
                'Professional quote and invoice PDFs on every plan',
                'Client database and branded documents',
                'Team member portal with project permissions (Pro)',
                'Projects, material search, and job costs (Pro)',
              ].map((item) => (
                <li key={item} className="flex items-center gap-2">
                  <svg className="h-4 w-4 shrink-0 text-cyan-300" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="flex animate-float justify-center">
            <div className="w-full max-w-sm overflow-hidden rounded-xl border-4 border-gray-200 bg-white shadow-2xl sm:max-w-lg md:max-w-xl lg:max-w-2xl">
              <div className="w-full h-full">
                <div className="flex items-center space-x-2 border-b border-gray-200 bg-gray-100 px-4 py-2">
                  <div className="flex space-x-1">
                    <div className="h-2.5 w-2.5 rounded-full bg-red-400 sm:h-3 sm:w-3" />
                    <div className="h-2.5 w-2.5 rounded-full bg-yellow-400 sm:h-3 sm:w-3" />
                    <div className="h-2.5 w-2.5 rounded-full bg-green-400 sm:h-3 sm:w-3" />
                  </div>
                  <div className="flex-1 rounded bg-white px-3 py-1 text-center text-xs text-gray-500">devellotech.ca</div>
                </div>
                <div className="relative w-full">
                  <img
                    src="/dashboard.png"
                    alt="DevelloTech invoices and dashboard"
                    className="block h-auto w-full max-h-[260px] object-contain sm:max-h-[350px] md:max-h-[450px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
